module.exports = __webpack_public_path__ + "ded84673c882505385d3b0de796c584f.gif";